import React from 'react';
import './Project.css';
import Card from 'react-bootstrap/Card';
import {Button} from 'react-bootstrap';
import luggage from '../../assets/images/luggage.png';
import hacktober from '../../assets/images/hacktober.png';
import todo from '../../assets/images/todo.jpeg';

export default class Projects extends React.Component {
    render() {
        return (
            <section className="projects-section container-fluid" id="projects">
                <h1 className="project-heading">Projects:</h1>
                <div className="card-div">
                
                <Card className="card" bg="light">
                    <Card.Img variant="top" className="card-image" src={luggage} />
                    <Card.Body>
                        <Card.Title>Travel4Brews</Card.Title>
                        <Card.Text>
                        This is a simple basic website on tours & travels ✈
                        </Card.Text>
                        <a href="https://bansalpravesh1.github.io/Travel4Brews/"><Button variant="primary">Visit Website</Button></a>
                    </Card.Body>
                </Card>
        
                <Card className="card"  bg="light">
                    <Card.Img variant="top" src={hacktober} className="card-image" />
                    <Card.Body>
                        <Card.Title>Hacktober Fest</Card.Title>
                        <Card.Text>
                            Created a public repo for Hacktober Fest 2020 💥
                        </Card.Text>
                        <a href="https://github.com/bansalpravesh1/HacktoberFest2020"><Button variant="primary">Check repo</Button></a>
                    </Card.Body>
                </Card>
                
                <Card className="card" bg="light">
                    <Card.Img variant="top" src={todo} style={{height:'16rem'}} />
                    <Card.Body>
                        <Card.Title>To-Do list</Card.Title>
                        <Card.Text>
                        Their is an simple todo list using reactjs. 📝
                        </Card.Text>
                        <a href="https://bansalpravesh1.github.io/Todo-s-list/"><Button class="button">Visit Website</Button></a>
                    </Card.Body>
                </Card>
                
            </div>
                
            </section>
        );
    }
}